import { axiosInstance } from '../axios';
import type { PaginatedResponse, ApiResponse } from '../../types/common';
import type {
  SupportTicketListDto,
  SupportTicketDetailDto,
  GetTicketsParams,
  TicketStatsDto,
} from '../../types/ticket';

export const ticketsApi = {
  getList: (params: GetTicketsParams) =>
    axiosInstance.get<PaginatedResponse<SupportTicketListDto>>('/v1/product-admin/support-tickets', { params }),

  getDetail: (id: number) =>
    axiosInstance.get<ApiResponse<SupportTicketDetailDto>>(`/v1/product-admin/support-tickets/${id}`),

  getStats: () =>
    axiosInstance.get<ApiResponse<TicketStatsDto>>('/v1/product-admin/support-tickets/stats'),

  assign: (id: number, assignedTo: string) =>
    axiosInstance.patch<ApiResponse<void>>(`/v1/product-admin/support-tickets/${id}/assign`, { assignedTo }),

  updateStatus: (id: number, status: string, resolution?: string) =>
    axiosInstance.patch<ApiResponse<void>>(`/v1/product-admin/support-tickets/${id}/status`, { status, resolution }),

  addComment: (id: number, comment: string, isInternal: boolean, attachmentsJson?: string) =>
    axiosInstance.post<ApiResponse<void>>(`/v1/product-admin/support-tickets/${id}/comments`, {
      comment,
      isInternal,
      attachmentsJson,
    }),
};
